/* eslint-disable @typescript-eslint/no-explicit-any */
import { IPG, WordItem } from "@/types/summary";
import { useEffect, useState } from "react";
import MarkIcon from "@/assets/summary/ic_mark.svg?react";
import { formatRecordTime } from "@/utils/formatter";
import "./index.less";
import SpeakPeople from "../SpeakPeople";
import { getSpeakerAvatarInfo } from "@/utils/newAvatar";
import GeneratingAvatar from "@/assets/svg/ic_generating_avatar.svg";
import SpeakerAvatar from "@/pages/Voice/SpearkerAvatar";
import EditRecordItem from "../EditRecordItem";
import { SRC_CONTENT_CLASSNAME } from "@/constants/record";
import { IBlurParaInfo } from "@/types/record";

export interface EditItem {
  wi: string;
  newContent: string;
}

export interface IDocItemProps {
  record: IPG;
  /** 生成中状态 */
  isGenerating?: boolean;
  /** 非稳态 */
  unstableText?: string;
  /** 非稳态时间 */
  unstableTime?: number;
  /** 占位 */
  placeholder?: string;
  /** 是否为编辑态 */
  isEditing?: boolean;
  handleEdit: (pi: string, editItems: EditItem[], emptyWordAllowed: boolean) => void;
  handleEnter?: (editItem: EditItem, cIndex: number, pi: string) => void;
  handleMerge?: (pi: string) => void;
  handleMark?: (pi: string, markFlag: boolean) => void;
  handleEditSpeaker?: (pi: string, newSpeakName: string[]) => void;
  recomputeRowHeights?: () => void;
  onBlur?: (para: IBlurParaInfo)=> void;
}

export interface SpeakItemRef {
  focus: () => void;
  placeCaretAtEnd: () => void;
}

const SpeakItem = (props: IDocItemProps) => {
  const { record, isGenerating, unstableText, unstableTime, placeholder, handleMark, handleEditSpeaker, ...rest } = props;
  const [containerHover, setContainerHover] = useState(false);
  const [hasMark, setHasMark] = useState(false);

  useEffect(() => {
    const words = record.sc.reduce((acc, cur) => acc.concat(cur.words), [] as WordItem[]);
    const hasMark = words.some((word) => word.mark);
    setHasMark(hasMark);
  }, [record]);

  const handleEditSingle = (name: string) => {
    console.log("handleEditSingle", name);
    handleEditSpeaker?.(record.pi, [name]);
  };

  const speakerAvatarInfo = getSpeakerAvatarInfo(record.headImage);
  const speakContent = record.sc?.flatMap((scItem) => scItem.words).map((wordItem) => wordItem.word).join("");
  const withoutSpeakerInfo = isGenerating && !speakContent?.length;

  return (
    <div
      className={`mb-6 w-50% mx-auto lazy-item`}
      onMouseEnter={() => {
        setContainerHover(true);
      }}
      onMouseLeave={() => {
        setContainerHover(false);
      }}
    >
      {/* 发言人 */}
      <div className="flex items-center text-#A1A7B2 text-3.5 font-400 pb-2.5 relative">
        {(!record.headImage || withoutSpeakerInfo) ? (
          <img
            src={GeneratingAvatar}
            className="h-6 size-6 absolute left--10"
          />
        ) : (
          <SpeakerAvatar
            speakerName={record.speakerName[0]}
            avatarIndex={speakerAvatarInfo.avatarIndex}
            useDefaultAvatarIcon={record.useDefaultIcon}
            className="h-6 size-6 absolute left--10"
          />
        )}
        <div className="h-6 flex items-center">
          <SpeakPeople allowEdit={!withoutSpeakerInfo && !!record.speakerName?.length} isGenerating={isGenerating} record={record} handleEditSpeaker={handleEditSingle} />
          {formatRecordTime((record.sc[0]?.words[0]?.bt || record.sc[0]?.bt || unstableTime || 0) / 1000) || "00:00"}
        </div>
        {containerHover && !!speakContent?.length && (
          <>
            <div className="right--17 top-10 absolute h-10">
              <div
                className={`relative ${
                  hasMark ? "left-9" : "left-2"
                }  h-8 p-1 px-2 cursor-pointer rounded-1.5 bg-#fff flex justify-center items-center shadow-[0_4px_16px_0_rgba(25,29,38,0.12)] active:bg-#F4F6F9`}
                onClick={() => handleMark?.(record.pi, !hasMark)}
              >
                <MarkIcon className="size-4 mr-2" />
                <span className="text-3.5 color-#626773">{hasMark ? "取消标记" : "标记"}</span>
              </div>
            </div>
          </>
        )}
      </div>
      {/* 编辑框 */}
      <div
        className={`${SRC_CONTENT_CLASSNAME} ${
          isGenerating ? " bg-mx-primary b-transparent" : "bg-#E1E8F5 b-#FFFFFF b-opacity-60"
        }  ${"hover:b-mx-primary hover:b-opacity-50"} min-h-12 px-4 py-3 rounded-4 rounded-lt-0 b-1 b-solid text-mx-tertiary text-justify lh-6 focus-visible:b-mx-primary focus-visible:outline-none`}
      >
        <EditRecordItem record={record} isGenerating={isGenerating} {...rest} />
        {unstableText && <span className="color-#fff color-opacity-50 text-3.5">{unstableText}</span>}
        {isGenerating && !record.sc.length && !unstableText && placeholder && <div className="text-#fff/50 text-3.5">{placeholder}</div>}
      </div>
    </div>
  );
};

export default SpeakItem;
